import fetchAPI from "./fetchAPI"

export default async function postToSuperOffice(formData) {
  const data = {
    formId: formData.formId,
    areaOfChoice: parseInt(formData.article, 10) || 0,
    totalAmount: formData.paymentAmount.amountValue,
    orgNr: formData.userDetails.orgNo,
    companyName: formData.userDetails.companyName,
    PostAddress: formData.userDetails.address,
    PostNumber: formData.userDetails.zip,
    PostCity: formData.userDetails.city,
    InvoiceAddress: formData.userDetails.InvoiceAddress,
    InvoicePostNumber: formData.userDetails.InvoicePostNumber,
    InvoiceCity: formData.userDetails.InvoiceCity,
    InvoiceEmail: formData.userDetails.InvoiceEmail,
    personFirstname: formData.userDetails.firstName,
    personLastname: formData.userDetails.lastName,
    personEmail: formData.userDetails.email,
    personPhonenumber: formData.userDetails.phone,
    customInvoice: formData.userDetails.customInvoice,
    sourceUrl: formData.sourceUrl,
    giftType: formData.campaignName
  }

  const token = formData.token

  const { postToSuperOffice } = await fetchAPI(
    `mutation($data: JSON!, $token: String!) {
        postToSuperOffice(data: $data, token: $token) {
        error,
        response
      }
    }`,
    {
      variables: {
        data,
        token
      }
    }
  )

  return postToSuperOffice
}
